import { render, staticRenderFns } from "./payback-datahandle.vue?vue&type=template&id=10167be8&scoped=true&"
import script from "./payback-datahandle.vue?vue&type=script&lang=js&"
export * from "./payback-datahandle.vue?vue&type=script&lang=js&"
import style0 from "./payback-datahandle.vue?vue&type=style&index=0&id=10167be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10167be8",
  null
  
)

export default component.exports